import { GetChipset, GetContentChipsDraft } from '../../connection/content-chips';
import { EntityType } from '../../types/enums';
import { Action, AsyncAction } from '../types/types';

export const SET_HANGING_USER_ID = 'SET_HANGING_USER_ID';
export const LOAD_CHIPSET = 'LOAD_CHIPSET';
export const SET_CHANNEL = 'SET_CHANNEL';
export const CLEAR_CHIPSET = 'CLEAR_CHIPSET';
export const LOAD_CHIPSET_DRAFT = 'LOAD_CHIPSET_DRAFT';
export const UPDATE_CHIPSET_DRAFT = `${EntityType.contentChips}-edit`;
export const CLEAR_CHIPSET_DRAFT = 'CLEAR_CHIPSET_DRAFT';

export const SetHangingChipUser = (payload: {
	uniqueContentId: string,
	userId: number | null
}): Action  => ({type: SET_HANGING_USER_ID, payload});

export const LoadChipset = (
	channelId: number,
	contentId: number
): AsyncAction => ({
	type: LOAD_CHIPSET,
	promise: GetChipset(channelId, contentId)
});

export const LoadChipsetDraft = (
	roomId: number,
	contentId: number
): AsyncAction => ({
	type: LOAD_CHIPSET_DRAFT,
	promise: GetContentChipsDraft(roomId, contentId)
});

export const SetChipChannel = (
	payload: number
): Action  => ({type: SET_CHANNEL, payload});

export const ClearChipset = (
	payload: null
): Action  => ({type: CLEAR_CHIPSET, payload});

export const ClearChipsetDraft = (
	payload: null
): Action  => ({type: CLEAR_CHIPSET_DRAFT, payload});